import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Alert } from '../components'
import { useNetworkConnection, useAlert } from '../hooks'
import { useTranslation } from 'react-i18next'
import Nav from './Nav'
import { offlineIcon } from 'assets'
import { isVeLikeRole } from 'helpers'

export const NetworkNavbar = ({ user }) => {
    const { isOnline, isValidCSPong } = useNetworkConnection()

    const [displayAlert, setDisplayAlert] = useAlert(2500)
    const { status } = useSelector((store) => store.navbar)
    const { username, role } = user || {}
    const { t } = useTranslation()

    const isVe = isVeLikeRole(role)

    const getAlert = ({ status, message, iconText, iconType }) => {
        return (
            <Alert
                icon
                iconText={iconText}
                iconType={iconType}
                status={status}
                type="floating"
            >
                {message}
            </Alert>
        )
    }

    useEffect(() => {
        setDisplayAlert((prevState) => {
            if (!prevState && isOnline) {
                return true
            } else if (prevState === null && !isOnline) {
                return false
            } else {
                return null
            }
        })
    }, [isOnline])

    const networkAlert = (
        <div className="sticky-network-alert">
            <div>
                {isOnline ? (
                    <Alert
                        status="success"
                        prefixText={isVe && isValidCSPong && `(${username})`}
                    >
                        {isValidCSPong ? (
                            t('networkBarOnline')
                        ) : (
                            <span className="text--error">
                                {t('connectUnavailable')}
                            </span>
                        )}{' '}
                        <span className="version--text">
                            {process.env.REACT_APP_APP_VERSION}
                        </span>
                    </Alert>
                ) : (
                    <Alert
                        status="error"
                        prefixText={isVe && `(${username})`}
                        icon
                        iconType={offlineIcon}
                        iconText={t('offline')}
                    >
                        {t('networkOffline')}
                    </Alert>
                )}
            </div>
        </div>
    )

    const popupAlert =
        displayAlert !== null
            ? displayAlert
                ? getAlert({
                      status: 'success',
                      message: t('onlineAgain')
                  })
                : getAlert({
                      status: 'error',
                      message: t('noInternet'),
                      iconText: t('offline'),
                      iconType: offlineIcon
                  })
            : ''

    const statusConfig = {
        SHOW_FULL: (
            <>
                {networkAlert} <Nav user={user} /> {popupAlert}
            </>
        ),
        HIDE_FULL: <></>,
        HIDE_NAV: (
            <>
                {networkAlert} {popupAlert}
            </>
        )
    }

    return statusConfig[status]
}
